import RequestAbstract from '../abstract';

export default class SystemMessages extends RequestAbstract {
    data;

    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/system-messages';
    }

    async getAllFiltered(
        filter = [],
        sort = [{ field: 'dateModified', direction: 'DESC' }],
        props = {}
    ) {
        const paging = props.paging || { page: 0, pageSize: 25 };

        try {
            const query = new URLSearchParams();
            query.append('page', paging.page ?? 0);
            query.append('pageSize', paging.pageSize ?? 25);

            if (sort?.length) {
                query.append('sortField', sort[0].field);
                query.append('sortDirection', sort[0].direction);
            }

            if (filter?.length) {
                query.append('filter', JSON.stringify(filter));
            }

            const getResult = await this.get(`${this.link}/?${query.toString()}`);
            if (getResult?.error === 'OK' || Array.isArray(getResult?.data)) {
                return getResult;
            }
        } catch (error) {
            // fallback to POST list request for compatible backends
        }

        return await this.post(`${this.link}/`, {
            filter,
            sort,
            paging
        });
    }

    async add(info) {
        return await this.loadWithAuth(`${this.link}/add`, {
            method: 'POST',
            body: JSON.stringify(info)
        });
    }

    async update(id, info) {
        return await this.loadWithAuth(`${this.link}/update/${id}`, {
            method: 'POST',
            body: JSON.stringify(info)
        });
    }

    async delete(ids) {
        const preparedIds = Array.isArray(ids) ? ids.join(',') : `${ids}`;

        const primary = await this.loadWithAuth(`${this.link}/${preparedIds}`, {
            method: 'DELETE'
        });

        if (primary?.error === 'OK') {
            return primary;
        }

        return await this.loadWithAuth(`${this.link}/delete/${preparedIds}`, {
            method: 'DELETE'
        });
    }

    async getHistory(id) {
        return await this.get(`${this.link}/get-history/${id}`);
    }
}
